module.exports = __webpack_public_path__ + "4fd446f9343a57e0db794982b6cec452.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/itcavantgardestd-bold-webfont.svg
 ** module id = 377
 ** module chunks = 0
 **/